import {
  ShieldCheck,
  Heart,
  Users,
  MessageCircle,
  User,
  Shield,
  LogOut,
  Compass,
} from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../components/ui/tooltip";

const navItems = [
  { id: "discovery", icon: Compass, label: "Discover" },
  { id: "matches", icon: Heart, label: "Matches" },
  { id: "chat", icon: MessageCircle, label: "Messages" },
  { id: "profile", icon: User, label: "Profile" },
];

export default function Sidebar({ activeView, onViewChange, isAdmin, onLogout }) {
  return (
    <>
      {/* Desktop Sidebar */}
      <div className="sidebar hidden md:flex">
        <div className="sidebar-logo">
          <ShieldCheck className="w-7 h-7 text-[#00FF66]" />
        </div>

        <nav className="sidebar-nav">
          <TooltipProvider delayDuration={0}>
            {navItems.map((item) => (
              <Tooltip key={item.id}>
                <TooltipTrigger asChild>
                  <button
                    data-testid={`nav-${item.id}`}
                    onClick={() => onViewChange(item.id)}
                    className={`sidebar-item ${
                      activeView === item.id ? "active" : ""
                    }`}
                  >
                    <item.icon size={20} />
                  </button>
                </TooltipTrigger>
                <TooltipContent side="right" className="bg-[#14151A] text-[#FAFAFA] border-[#1F2027] rounded-none text-xs">
                  {item.label}
                </TooltipContent>
              </Tooltip>
            ))}

            {isAdmin && (
              <Tooltip>
                <TooltipTrigger asChild>
                  <button
                    data-testid="nav-admin"
                    onClick={() => onViewChange("admin")}
                    className={`sidebar-item ${
                      activeView === "admin" ? "active" : ""
                    }`}
                  >
                    <Shield size={20} />
                  </button>
                </TooltipTrigger>
                <TooltipContent side="right" className="bg-[#14151A] text-[#FAFAFA] border-[#1F2027] rounded-none text-xs">
                  Admin Panel
                </TooltipContent>
              </Tooltip>
            )}
          </TooltipProvider>
        </nav>

        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                data-testid="nav-logout"
                onClick={onLogout}
                className="sidebar-item mt-auto"
              >
                <LogOut size={20} />
              </button>
            </TooltipTrigger>
            <TooltipContent side="right" className="bg-[#14151A] text-[#FAFAFA] border-[#1F2027] rounded-none text-xs">
              Sign Out
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      {/* Mobile Bottom Nav */}
      <div className="mobile-nav">
        {navItems.map((item) => (
          <button
            key={item.id}
            data-testid={`mobile-nav-${item.id}`}
            onClick={() => onViewChange(item.id)}
            className={`flex flex-col items-center justify-center gap-1 px-3 py-1 transition-colors ${
              activeView === item.id
                ? "text-[#00FF66]"
                : "text-[#8A8A93]"
            }`}
          >
            <item.icon size={18} />
            <span className="text-[10px]">{item.label}</span>
          </button>
        ))}
        {isAdmin && (
          <button
            data-testid="mobile-nav-admin"
            onClick={() => onViewChange("admin")}
            className={`flex flex-col items-center justify-center gap-1 px-3 py-1 transition-colors ${
              activeView === "admin" ? "text-[#00FF66]" : "text-[#8A8A93]"
            }`}
          >
            <Shield size={18} />
            <span className="text-[10px]">Admin</span>
          </button>
        )}
        <button
          data-testid="mobile-nav-logout"
          onClick={onLogout}
          className="flex flex-col items-center justify-center gap-1 px-3 py-1 text-[#8A8A93]"
        >
          <LogOut size={18} />
          <span className="text-[10px]">Exit</span>
        </button>
      </div>
    </>
  );
}
